/* SCC CUSTOM START | finder-view-buy | Purpose: apply approved purchase controls to finder cards | Added: 2026-10-31 */
(function () {
'use strict';
window.SCCFinderCards = { hardware: function(card,p) {
if(!p.purchase_html)return card;
card.classList.add('scc-custom-card');
const body=card.querySelector('.sf-card-body');body.classList.add('scc-custom-card__body');
card.querySelector(':scope > a').classList.add('scc-custom-card__image');
card.querySelector('h3 a').classList.add('scc-custom-card__title');
card.querySelector('.sf-price').classList.add('scc-custom-card__price');
card.querySelector('.sf-stock').classList.add('scc-custom-card__stock');
card.querySelector('.sf-view').remove();
const t=document.createElement('template');t.innerHTML=p.purchase_html;body.append(t.content);
},
endpoint: function (url) { if(window.SCCFinderPreviewTheme)url.searchParams.set('preview_theme_id',window.SCCFinderPreviewTheme);else url.searchParams.delete('preview_theme_id'); return url; }, enhance: function (article, product) {
  if (!product.purchase_html) return article;
  article.classList.add('scc-custom-card');
  const pairs = [['sg-image','scc-custom-card__image'],['sg-card-body','scc-custom-card__body'],['sg-sku','scc-custom-card__sku'],['sg-title','scc-custom-card__title'],['sg-specs','scc-custom-card__specs'],['sg-price','scc-custom-card__price'],['sg-stock','scc-custom-card__stock']];
  pairs.forEach(function (pair) { const node=article.querySelector('.'+pair[0]); if(node){node.classList.remove(pair[0]);node.classList.add(pair[1]);} });
  const old=article.querySelector('.sg-view');
  if(old)old.remove();
  const body=article.querySelector('.scc-custom-card__body');
  const template=document.createElement('template');
  template.innerHTML=product.purchase_html;
  body.append(template.content);
  article.querySelectorAll('a[href]').forEach(function(a){const u=new URL(a.href,location.origin);u.searchParams.delete('preview_theme_id');u.searchParams.delete('_fd');u.searchParams.delete('pb');a.href=u.pathname+u.search+u.hash;});
  return article;
}};
})();
/* SCC CUSTOM END | finder-view-buy */